import { render, staticRenderFns } from "./VSelectProfesion.vue?vue&type=template&id=13982930&"
import script from "./VSelectProfesion.vue?vue&type=script&lang=js&"
export * from "./VSelectProfesion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports